<template>
  <div
    v-if="notification"
    class="mb-1"
  >
    <b-alert
      v-for="notif in notification"
      :key="notif.id"
      :show="true"
      dismissible
      class="p-1"
      :style="`background-color: ${notif.color} !important`"
      @dismissed="dismissNotificationBar(notif)"
    >
      <span
        class="text-[#222222] text-[20px] font-bold"
      >{{ notif.title }}</span><br>
      <div
        class="text-[#222222] text-[16px] font-normal"
        style="max-width: 90%;"
      >
        {{ notif.description }}&nbsp;
        <a
          class="text-[#222222] hover:text-[#222222] font-semibold"
          :href="notif.url_link"
          target="_blank"
        >{{ notif.url_link }}</a>
      </div>

      <template slot="dismiss">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
          style="cursor:pointer"
        >
      </template>
    </b-alert>
  </div>
</template>
<script>
import useJwt from '@/auth/jwt/useJwt'

export default {
  computed: {
    notification() {
      const allNotifications = this.$store.getters['notification/messages']
      const dismissed = this.getDismissedNotifications()
      return allNotifications.filter(n => !dismissed.includes(n.id))
    },
  },
  mounted() {
    const token = useJwt.getToken()
    if (!token) return
    this.$store.dispatch('notification/fetchNotifications')
  },
  methods: {
    dismissNotificationBar(notif) {
      this.$store.dispatch('notification/dismissMessage', notif.id)

      this.saveDismissedNotification(notif.id)
    },

    getDismissedNotifications() {
      const dismissed = localStorage.getItem('dismissedNotifs')
      return dismissed ? JSON.parse(dismissed) : []
    },

    saveDismissedNotification(id) {
      const dismissed = this.getDismissedNotifications()
      if (!dismissed.includes(id)) {
        dismissed.push(id)
        localStorage.setItem('dismissedNotifs', JSON.stringify(dismissed))
      }
    },
  },
}
</script>
